import type { RoomType } from "@/types";
import type { QuizAnswers } from "@/lib/pipeline/style-profile";

const DEFAULT_LIVING_ELEMENTS = [
  { name: "Paint / Wallpaper", selected: true },
  { name: "Sofa", selected: true, option: "3 seater" },
  { name: "Armchair", selected: true, option: "1" },
  { name: "Coffee Table", selected: true },
  { name: "Side Table", selected: true },
  { name: "Console Table", selected: false },
  { name: "Sideboard", selected: false },
  { name: "TV Unit", selected: false },
  { name: "Shelving", selected: false },
  { name: "Storage", selected: false },
  { name: "Rug", selected: true },
  { name: "Curtains", selected: false },
  { name: "Ceiling Light", selected: true },
  { name: "Floor Lamp", selected: false },
  { name: "Table Lamp", selected: false },
  { name: "Wall Light", selected: false },
  { name: "Wall Art", selected: true },
  { name: "Mirror", selected: false },
  { name: "Cushions", selected: true },
  { name: "Throws", selected: false },
  { name: "Decor", selected: true },
];

const DEFAULT_BEDROOM_ELEMENTS = [
  { name: "Paint / Wallpaper", selected: true },
  { name: "Bed Frame", selected: true, option: "Double" },
  { name: "Mattress", selected: true },
  { name: "Bedding", selected: false },
  { name: "Bedside Table", selected: true, option: "2" },
  { name: "Chest of Drawers", selected: true },
  { name: "Wardrobe", selected: false },
  { name: "Storage", selected: false },
  { name: "Rug", selected: true },
  { name: "Curtains", selected: false },
  { name: "Ceiling Light", selected: true },
  { name: "Table Lamp", selected: false },
  { name: "Floor Lamp", selected: false },
  { name: "Wall Light", selected: false },
  { name: "Wall Art", selected: true },
  { name: "Mirror", selected: false },
  { name: "Cushions", selected: true },
  { name: "Throws", selected: false },
  { name: "Decor", selected: true },
];

export function getDefaultElements(roomType: RoomType): QuizAnswers["elementsToAdd"] {
  const elements = roomType === "bedroom" ? DEFAULT_BEDROOM_ELEMENTS : DEFAULT_LIVING_ELEMENTS;
  return elements.map(element => ({ ...element }));
}

export function createQuizAnswers(roomType: RoomType): QuizAnswers {
  return {
    roomType,
    styleAesthetic: ["Warm Editorial"],
    colorMood: "soft",
    lifeFactors: [],
    approxWidthMeters: 4,
    elementsToAdd: getDefaultElements(roomType),
    brands: [],
    feeling: "",
  };
}
